// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".card_cardHeader__3QlUF {\n    padding-top: 60px;\n    padding-bottom: 60px;\n    color: white !important;\n    text-align: center;\n}\n\n", "",{"version":3,"sources":["webpack://src/components/card/card.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,kBAAkB;AACtB","sourcesContent":[".cardHeader {\n    padding-top: 60px;\n    padding-bottom: 60px;\n    color: white !important;\n    text-align: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardHeader": "card_cardHeader__3QlUF"
};
export default ___CSS_LOADER_EXPORT___;
